var utils = (function(){
	function equalHeights(container,attributeName,dimension){
		var container_selector = container != null ? container : "eq-container";
		var data_attribute_name = attributeName != null ? attributeName : "data-items";
		var dimension = dimension != null ? dimension : "height";
		
		if(document.getElementsByClassName(container_selector).length>0){
			var containers_list = document.getElementsByClassName(container_selector);
			var containers_array = Array.prototype.slice.call(containers_list);
			
			for (var idx in containers_array) {
				try {
					var this_container = containers_array[idx];
					var elements_list_string = this_container.getAttribute(data_attribute_name);
					var elements_list_array = elements_list_string.split(",");
	
					for (var idx in elements_list_array) {
						try {
							var elem = elements_list_array[idx];
							var eq_element_list = this_container.querySelectorAll(elem.trim());
							var eq_element_array = Array.prototype.slice.call(eq_element_list);
							var dimensions_list = eq_element_array.map(function(this_element){return getDimension(this_element,dimension)});
							var max_dimension = dimensions_list.reduce(function(a, b) {return Math.max(a, b);})
							for (var idx in eq_element_array) {
								setDimension(eq_element_array[idx],dimension,max_dimension);
							}
						} catch(e) {
							console.warn('equalHeights[Warning]: ' + e.name + '\nDescription: ' + e.message);
						}
					};
				} catch(e) {
					console.warn('equalHeights[Warning]: ' + e.name + '\nDescription: ' + e.message);
				}
			}
		}
	};
	
	function getDimension(elem,dimension){
		var value;
		
		switch (dimension){
			case "height":
				value = elem.offsetHeight;
				break;
			case "width":
				value = elem.offsetWidth;
				break;
			default:
				value = elem.offsetHeight;
		}
		return value;
	}
	
	function setDimension(elem,dimension,value){
		switch (dimension){
			case "height":
				elem.style.height = value + 'px';
				break;
			case "width":
				elem.style.width = value + 'px';
				break;
			default:
				elem.style.height = value + 'px';
		}
	}
	
	return {
		equalHeights: equalHeights
	}
})();
	
//utils.equalHeights();

// window.onresize = function() {
// 	utils.equalHeights();	
// };

// mail subscribe from footer
const email_regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
$('#mail__subscriber').on('click', function() {
	var email = $('#mce-EMAIL').val();
	if(email.length > 0 && email_regex.test(email)) {
		$('#mc-embedded-subscribe').click();
	}
});

// toggle hamburger
$(".hamburger").on("click", function() {
	$(".hamburger").toggleClass("is-active");
});

// Inner dropdown menu eventPreventDefault for touch devices
window.USER_IS_TOUCHING = false;
window.addEventListener('touchstart', function onFirstTouch() {
	USER_IS_TOUCHING = true;
	// we only need to know once that a human touched the screen, so we can stop listening now
	window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

function is_touch_device() {
	return 'ontouchstart' in window		// works on most browsers 
	|| navigator.maxTouchPoints;		// works on IE10/11 and Surface
};

// add disable class to swiperJS
$('.swiper-wrapper').each(function(index, element){
    var $this = $(this);
    var childrenLength = $this.children().length;

    if (childrenLength <= 4) {
		$this.addClass("disabled");
		//$this.children().addClass("disabled");
    }
});

$('.dropdown-cats .category--text-container .video-category-title').on('click', function(e) {
	var target = $(e.target);
	var parent = target.parent(); // the li
	if (is_touch_device() || window.USER_IS_TOUCHING) {
		if (target.hasClass("active")) {
			//run default action of the link
		}
		else{
			e.preventDefault();
			//remove class active from all links
			$('.dropdown-cats .category--text-container .video-category-title.active').removeClass('active');
			//set class active to current link
			target.addClass("active");
			parent.addClass("active");
		}
	}
});

$('.category--text-container').click(function(e) {
	//remove class active from all links if li was clicked
	if (e.target == this) {
		$(".active").removeClass('active');
	}
});

// open with 1 click language dropdown
$('.menu-language-container ul').on('click touch', function() {
	$('.sub-menu').css('display','block');
})

$('.trainers').slick({
  	dots: false,
  	prevArrow: '<p class="js-carousel-control carousel-slick__control carousel-slick__control--circle carousel-slick__control--left" data-carousel-direction="-1"><span class="visually-hidden">Previous</span><svg class="icon carousel-slick__control-icon"><svg viewBox="0 0 76 144" id="icon-chevron-left" width="100%" height="100%"><polyline id="chevron-left-a4e0e987-f44d-495f-8041-cbcac2454416" data-name="<Pfad>" points="72 140 4 72 72 4" stroke-linecap="round" stroke-linejoin="round"></polyline></svg></svg></p>',
	nextArrow: '<p class="js-carousel-control carousel-slick__control carousel-slick__control--circle carousel-slick__control--right" data-carousel-direction="1"> <span class="visually-hidden">Next</span><svg class="icon carousel-slick__control-icon"><svg viewBox="0 0 76 144" id="icon-chevron-right" width="100%" height="100%"><polyline id="chevron-right-2063ebf3-901a-4482-a254-6509fb6140e6" data-name="<Pfad>" points="4 4 72 72 4 140" stroke-linecap="round" stroke-linejoin="round"></polyline></svg></svg></p>',
  	infinite: true,
  	speed: 500,
  	fade: true,
  	cssEase: 'linear',
  	slidesToShow: 1,
  	slidesToScroll: 1,
  	autoplay: true,
  	autoplaySpeed: 4000
});

var workoutsCarousel = {
	dots: true,
  	infinite: true,
  	speed: 500,
  	fade: true,
	fadeSpeed: 1000,
  	cssEase: 'linear',
  	slidesToShow: 1,
  	slidesToScroll: 1,
  	autoplay: true,
  	autoplaySpeed: 4000,
	arrows: false,
	lazyload: 'ondemand'
};

/* Slick needs no get Reinitialized on window Resize after it was destroyed */
$(window).on('load resize orientationchange', function() {
	var $window = $(window).width();
	$('.workouts__inner-wrapper').each(function(){
		var $carousel = $(this);

		/* Initializes a slick carousel only on mobile screens */
		if ($window > 768) {
			if ($carousel.hasClass('slick-initialized')) {
				$carousel.slick('unslick');
			}
		}
		else {
			if (!$carousel.hasClass('slick-initialized')) {
				$carousel.slick(workoutsCarousel);
			}
		}
	});
});

// Stop video from modal
$('.modal').on('hidden.bs.modal', function(e) {
	var $iframes = $(e.target).find('iframe');
	var $src = $iframes.attr('data-src');
  	$iframes.each(function(index, iframe){
  		$(iframe).attr('src', $src);
  		$(iframe).removeAttr('src');
  		$(iframe).removeClass('lazyloaded').addClass('lazyload');
  	});
});

// Disable right click and copy/paste
$('body').on('contextmenu copy paste', '.lesson-container', function(){ 
	return false; 
});

$('.mepr-price-box').each(function() {
	var id = this.id.split("-");
	id = id[id.length - 1];
	meprId = `mepr-image-${id}`;
	$(this).find('.mepr-price-box-title').addClass("lazy").attr('id', meprId);
});

$(window).on('load', function() {
	$('.menu-item-has-children').on('click touch', function() {
		$('.main-navigation ul li > ul').toggle();
	});

	// Custom lazyload script using Intersection Observer
  	var lazyloadImages;    
  	if ("IntersectionObserver" in window) {
	    lazyloadImages = document.querySelectorAll(".lazy");
	    var imageObserver = new IntersectionObserver(function(entries, observer) {
	    	entries.forEach(function(entry) {
	        	if (entry.isIntersecting) {
	          		var image = entry.target;
	          		image.src = image.dataset.src;
	          		image.classList.remove("lazy");
	          		imageObserver.unobserve(image);
	        	}
	      	});
	    });

	    lazyloadImages.forEach(function(image) {
	      	imageObserver.observe(image);
	    });
  	} else {  
	    var lazyloadThrottleTimeout;
	    lazyloadImages = document.querySelectorAll(".lazy");
	    
	    function lazyload () {
	    	if(lazyloadThrottleTimeout) {
	        	clearTimeout(lazyloadThrottleTimeout);
	      	}    

	      	lazyloadThrottleTimeout = setTimeout(function() {
	        	var scrollTop = window.pageYOffset;
	        	lazyloadImages.forEach(function(img) {
	            	if(img.offsetTop < (window.innerHeight + scrollTop)) {
		              	img.src = img.dataset.src;
		              	img.classList.remove('lazy');
	            	}
	        	});
		        if(lazyloadImages.length == 0) { 
		        	document.removeEventListener("scroll", lazyload, {passive: true});
		          	window.removeEventListener("resize", lazyload, {passive: true});
		          	window.removeEventListener("orientationChange", lazyload, {passive: true});
		        }
	      	}, 20);
    	}

	    document.addEventListener("scroll", lazyload, {passive: true});
	    window.addEventListener("resize", lazyload, {passive: true});
	    window.addEventListener("orientationChange", lazyload, {passive: true});
  	}

	$("input[type='radio']").click(function(){
		var radioValue = $("input[name='gender']:checked").val();

	    if(radioValue === 'Male'){
	    	//JP3 Form
			$('#JP3-form .form-group.male').css("display","flex");
			$('#JP3-form .form-group.female').css("display","none");
			$("#JP3-form input[name='tricep']").removeAttr("required");
			$("#JP3-form input[name='suprailiac']").removeAttr("required");
			$('#JP3-form .form-group.male input').attr("required", "true");

			//US Navy Form
			$("#USnavy-form input[name='hip']").removeAttr("required");
			$("#USnavy-form .form-group.female").css("display","none");

			$('.gender-element.male').css('display','block');
			$('.table.table-bordered.male').css('display','table');
			$('.gender-element.female').css('display','none');
			$('.table.table-bordered.female').css('display','none');

			//Instruction JP3
			$('li.gender-element.male').css('display','list-item');
	    } else if(radioValue === 'Female'){ 

	    	//JP3 Form
	    	$('#JP3-form .form-group.female').css("display","flex");
			$('#JP3-form .form-group.male').css("display","none");
			$("#JP3-form input[name='chest']").removeAttr("required");
			$("#JP3-form input[name='abdomen']").removeAttr("required");
			$('#JP3-form .form-group.female input').attr("required", "true");

			//US Navy Form
			$('#USnavy-form .form-group.female').css("display","flex");
			$('#USnavy-form .form-group.female input').attr("required", "true");
			
			$('.gender-element.male').css('display','none');
			$('.table.table-bordered.male').css('display','none');
			$('.gender-element.female').css('display','block');
			$('.table.table-bordered.female').css('display','table');

			//Instruction JP3
			$('li.gender-element.female').css('display','list-item');
	    }
	});
	
	$('form input').blur(function(){
		if($(this).val() == ''){
			$(this).addClass("error");
		} else {
			$(this).removeClass("error");
		}
	});

	$(".reset").on('click', function(){
		$('input[type=text]').removeAttr('value');
	});

	// Accordion Functionality
	$('.toggle').click(function() {
	    if ($(this).next().hasClass('active')) {
	        $(this).next().removeClass('active');
	        $(this).next().slideUp(600);
	    } else {
	        $(this).parent().parent().find('li .inner').removeClass('active');
	        $(this).parent().parent().find('li .inner').slideUp(600);
	        $(this).next().toggleClass('active');
	        $(this).next().slideToggle(600);
	    }

		$(".toggle").each(function(){
			if ($(this).siblings('.inner').hasClass('active')) {
	    		$(this).parent().find('.toggle').addClass('active');
	    	} else {
	    		$(this).parent().find('.toggle').removeClass('active');
	    	}	
		});
	});

	// Parallax Functionality
	/*var parallaxElements = $('.wp-post-image'),
    parallaxQuantity = parallaxElements.length;

	$(window).on('scroll', function () {
  		window.requestAnimationFrame(function () {
			for (var i = 0; i < parallaxQuantity; i++) {
			var currentElement =  parallaxElements.eq(i);
			var scrolled = $(window).scrollTop();
				currentElement.css({
				'transform': 'translate3d(0,' + scrolled * -0.3 + 'px, 0)'
				});
			}
  		});
	});*/
	
	if (typeof AOS === "function") { 
		AOS.init({
			// Global settings:
			disable: window.innerWidth < 768, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
			startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
			initClassName: 'aos-init', // class applied after initialization
			animatedClassName: 'aos', // class applied on animation
			useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
			disableMutationObserver: false, // disables automatic mutations' detections (advanced)
			debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
			throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
		});
	}
})